const RELOAD_FLAG = "architect:chunk-reload";
const CHUNK_ERROR_PATTERN =
  /Loading chunk|Loading CSS chunk|Failed to (load|fetch).*(chunk|module script)|dynamically imported module|importing a module script failed/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  if (typeof error === "object" && "name" in error && (error as Error).name === "ChunkLoadError") {
    return true;
  }
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_ERROR_PATTERN.test(message);
}

export function reloadOnceForChunkError(error: unknown): boolean {
  if (typeof window === "undefined" || !isChunkLoadError(error)) return false;
  if (sessionStorage.getItem(RELOAD_FLAG)) return false;

  sessionStorage.setItem(RELOAD_FLAG, "1");
  window.location.reload();
  return true;
}

export function clearChunkReloadFlag() {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(RELOAD_FLAG);
}
